import { Button } from "@wondermaps/ui";

/** Full-page fallback for root error boundary */
export function AppErrorFallback({
  resetError,
}: {
  error: unknown;
  componentStack: string | null;
  eventId: string | null;
  resetError: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold text-foreground">
          Something went wrong
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          An unexpected error occurred. Our team has been notified.
        </p>
        <Button className="mt-4" onClick={resetError}>
          Try again
        </Button>
      </div>
    </div>
  );
}

/** Inline fallback for map canvas error boundary */
export function MapErrorFallback({
  resetError,
}: {
  error: unknown;
  componentStack: string | null;
  eventId: string | null;
  resetError: () => void;
}) {
  return (
    <div className="flex h-full w-full items-center justify-center bg-muted/50">
      <div className="text-center">
        <p className="text-sm font-medium text-foreground">
          Map failed to load
        </p>
        <button
          className="mt-2 text-sm text-primary underline"
          onClick={resetError}
        >
          Tap to retry
        </button>
      </div>
    </div>
  );
}
